import { ICustomService } from "@common/SelectYourNumber/interface/ISubscription";
import { STORAGE } from "@constants";
import { Storage } from "src/itsf/utils/storage";

const storage = () => new Storage(sessionStorage);

export const saveSelectedService = (selectedService: ICustomService | undefined) => {
    saveStorage({ selectedService });
};

const saveStorage = <T>(dataToStore: T) => {
    const newStorage = Object.assign(loadStorage() as any, dataToStore);
    storage().save(STORAGE, newStorage);
};

export default () => {
    storage().clear();
};

const loadStorage = <T>(): T => storage().load(STORAGE);

export const getSelectedService = () => loadStorage<{ selectedService?: ICustomService }>().selectedService;
